'use client';

import {
  Group,
  Image,
  Paper,
  Stack,
  Text,
  Title,
  UnstyledButton,
} from '@mantine/core';
import Link from 'next/link';

export interface ProductCardProps {
  id: string;
  title: string;
  price: number;
  previewUrl: string;
  comparePrice?: number;
}

export function ProductCard({
  id,
  title,
  previewUrl,
  price,
  comparePrice,
}: ProductCardProps) {
  return (
    <Paper withBorder p="sm">
      <UnstyledButton component={Link} href={`/products/${id}`}>
        <Stack gap="xs">
          <Image w="100%" radius="md" alt={title} src={previewUrl} />

          <Title order={5} lineClamp={2}>
            {title}
          </Title>

          <Group gap="xs" display="none">
            <Text>{price.toLocaleString()}</Text>

            {comparePrice && (
              <Text c="red" td="line-through" fz={12}>
                {comparePrice.toLocaleString()}
              </Text>
            )}
          </Group>
        </Stack>
      </UnstyledButton>
    </Paper>
  );
}
